import * as React from 'react';

import * as setup from './setup';
import { App } from './App';
import { render } from 'react-dom';

/*
TODO is this needed?

// If we reach this page without coming from somewhere (ie if we have not come from AEM)
// we will send the user back to allow AEM to create a proper handshake. This is a
// common scenario with things like bookmarking. We have relocated this redirect
// to here, and not the redirector component, to prevent the UI from showing
if (document.referrer === '' && !isNative()) {
  window.location.href = ConfigService.getLandingUrl();
}

*/

setup.initialiseApp();

const rendered = render(<App />, document.getElementById('root'));

export default rendered;
